/* eslint-disable import/prefer-default-export */
import { serializePaymentMethods } from '../utils/serializePaymentMethods';
import { shouldAddMercately } from '../utils/shouldAddMercately';
import { addMercatelyPaymentMethod } from '../utils/addMercatelyPaymentMethod';

export const buildPaymentMethods = ({ paymentMethods, retailerInfo, order }) => {
  const serialized = serializePaymentMethods(paymentMethods);

  return shouldAddMercately(retailerInfo)
    ? addMercatelyPaymentMethod(serialized, order)
    : serialized;
};
